import styled from 'styled-components';
import { brandColors } from 'styles/colors';
import { breakpoint, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

export const CardWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  border: 1px solid ${getColor('borderTertiary')};

  @media (${breakpoint.mdMin}) {
    max-width: 344px;
  }

  @media (${breakpoint.mdMin}) {
    flex-direction: column;
  }
`;

export const TopSectionWrapper = styled.div`
  background-color: ${brandColors.crypto.shadeBrandPrimary100};
  position: relative;
  padding: 16px 16px 8px;

  .check-svg, .checkmark {
    position: absolute;
    height: 24px;
    width: 24px;
    top: -7%;
    left: -10%;
  }

  @media (${breakpoint.mdMin}) {
    padding: 0 24px 16px;
    .check-svg, .checkmark {
      width: 32px;
      height: 32px;
      top: -10%;
      left: -8%;
    }
    &.guest {
      .check-svg {
        left: -5%;
      }
    }
  }
`;

export const CardLine = styled.div`
  height: 8px;
  background-color: ${brandColors.crypto.shadeBrandPrimary500};
`;

export const TitleWrapper = styled.div`
  @media (${breakpoint.mdMin}) {
    margin-top: 16px;
  }
`;

export const NewsletterFrequency = styled.div<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  color: ${getColor('textPrimary')};
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.5px;

  @media (${breakpoint.mdMin}) {
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const CardTitle = styled.div<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  color: ${getColor('textPrimary')};
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0.5px;
  min-width: 88px;
  margin-bottom: 16px;

  @media (${breakpoint.mdMin}) {
    font-size: 20px;
    line-height: 24px;
    height: 48px;
  }
`;

export const AuthorsLine = styled.div`
  font-family: ${font.graphikCond};
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 1px;
  display: flex;
`;

export const Authors = styled.div`
  font-family: ${font.graphikCond};
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: 1px;
  margin-left: 4px;
  text-transform: uppercase;
  display: contents;
`;

export const BottomSection = styled.div<{ theme: Theme }>`
  padding: 16px;
  background: ${getColor('backgroundPrimary')};

  @media (${breakpoint.mdMin}) {
    padding: 16px 24px;
  }
`;

export const CardDescription = styled.div<{ theme: Theme }>`
  font-family: ${font.graphikCond};
  color: ${getColor('textPrimary')};
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.5px;
  height: 117px;
  margin-bottom: 8px;
  overflow: hidden;

  p {
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
  }

  @media (${breakpoint.mdMin}) {
    line-height: 24px;
    height: 168px;
    p {
      -webkit-line-clamp: 7;
    }
  }
`;

export const SubscribeSection = styled.div<{ theme: Theme; hasSampleUrl: boolean }>`
  display: flex;
  justify-content: ${(props) => (props.hasSampleUrl ? 'space-between' : 'right')};
  align-items: center;

  .sub-button {
    height: 32px;

    &:hover {
      svg {
        fill: ${getColor('textLink')};
        stroke: ${getColor('textLink')};
      } 
    }
  }

  .link {
    font-size: 14px;

    @media (${breakpoint.mdMin}) {
      font-size: 16px;
    }
  }
`;
